import { createAction } from '@/utility/actions';

import {
  WEBHOOKS_GET_DICTIONARY,
  WEBHOOKS_ADD_CUSTOMER_CREDITS,
  WEBHOOKS_CANCEL_CUSTOMER_CREDITS,
  WEBHOOKS_UPDATE_CUSTOMER_CREDITS,
} from './_types.ts';

/**
 * getWebhooksDictionary
 * @returns {{types: *, action: *}}
 */
export const getWebhooksDictionary = createAction(WEBHOOKS_GET_DICTIONARY);

/**
 * addCustomerCredits
 * @param {{object}} data
 * @returns {{types: *, action: *}}
 */
export const addCustomerCredits = createAction(WEBHOOKS_ADD_CUSTOMER_CREDITS);

/**
 * updateCustomerCredits
 * @param {{object}} data
 * @returns {{types: *, action: *}}
 */
export const updateCustomerCredits = createAction(WEBHOOKS_UPDATE_CUSTOMER_CREDITS);

/**
 * cancelCustomerCredits
 * @param {{object}} data
 * @returns {{types: *, action: *}}
 */
export const cancelCustomerCredits = createAction(WEBHOOKS_CANCEL_CUSTOMER_CREDITS);

export default {
  getWebhooksDictionary,
  addCustomerCredits,
  updateCustomerCredits,
  cancelCustomerCredits,
};
